<template>
    <v-chart class="chart" :option="option" :autoresize=true />
</template>

<script>
import * as echarts from 'echarts';
import VChart, { THEME_KEY } from "vue-echarts";
import { ref, defineComponent } from "vue";

export default defineComponent({
    name: "echart",
    components: {
        VChart
    },
    provide: {
        [THEME_KEY]: "dark"
    },
    setup () {
        const option = ref({
            color: ['#f5365c', '#5e72e4', '#fb6340', '#ffd600', '#7ec365', '#2dce89', '#11cdef', '#5603ad', '#f3a4b5', '#8898aa', '#000'],
            title: {
                text: "",
                left: "center"
            },
            tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
                orient: "vertical",
                right: "0",
                top: "0",
                data: []
            },
            toolbox: {
                showTitle: false,
                show: true,
                orient: 'vertical',
                left: 'right',
                top: 'bottom',
                feature: {
                    mark: { show: true },
                    saveAsImage: {title: "Als Bild speichern", show: true }
                },
                tooltip: { // same as option.tooltip
                    show: true,
                    formatter: function (param) {
                        return '<div>' + param.title + '</div>'; // user-defined DOM structure
                    },
                    backgroundColor: '#f7f8fd',
                    textStyle: {
                        fontSize: 12,
                    },
                    extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);' // user-defined CSS styles
                }
            },
            series: [
                {
                    name: "Incidents",
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: [],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)"
                        }
                    }
                }
            ]
        });

        return { option };
    }
});
</script>

<style scoped>
.chart {
    height: 420px;
}
</style>
